import { createFileRoute } from "@tanstack/react-router";
import { useRole } from "@/hooks/use-role";
import { PermissionDeniedPage } from "@/components/team/PermissionDeniedPage";
import { TextCreateFlow } from "@/components/text-banking/TextCreateFlow";

interface NewTextSearch {
	/** Preselects this action group in the wizard's Audience step (e.g. when
	 *  arriving from the action-groups page's "Text" button). */
	actionGroupId?: number;
}

export const Route = createFileRoute("/_app/_/text-banking/new")({
	validateSearch: (search: Record<string, unknown>): NewTextSearch => ({
		actionGroupId:
			typeof search.actionGroupId === "number"
				? search.actionGroupId
				: typeof search.actionGroupId === "string" &&
						/^\d+$/.test(search.actionGroupId)
					? Number(search.actionGroupId)
					: undefined,
	}),
	component: TextBankingNewPage,
});

function TextBankingNewPage() {
	const { isReadWrite } = useRole();
	if (!isReadWrite) {
		return (
			<PermissionDeniedPage
				requiredRole="Read/Write"
				message="You need Read/Write or Admin access to create a text campaign."
			/>
		);
	}
	const { actionGroupId } = Route.useSearch();
	return (
		<div className="p-6">
			<TextCreateFlow initialActionGroupId={actionGroupId ?? null} />
		</div>
	)
}
